/*
 JS Specific for the Specific Patients page
 */

specificPatients = {
	init: function initialize(){
		this.cE();
	},
	cE: function cacheElements(){
		specificPatients.pathname = window.location.pathname;
		specificPatients.urlArray = specificPatients.pathname.split('/');
		specificPatients.urlObject = {
			'is-livalo-right-statin': $('#tab-overview'),
			'statin-and-blood-sugar': $('#tab-t2d'),
			'statin-for-65-and-older': $('#tab-elderly'),
			'statin-calcium-channel-blocker-interaction': $('#tab-ccb'),
			'cholesterol-coronary-heart-disease-risks': $('#tab-chd'),
			'statin-warfarin-interaction': $('#tab-warfarin'),
			'asian-patients-with-cholesterol': $('#tab-asian')
		};
		specificPatients.urlObjectMobile = {
			'is-livalo-right-statin': $('#overview'),
			'statin-and-blood-sugar': $('#t2d'),
			'statin-for-65-and-older': $('#elderly'),
			'statin-calcium-channel-blocker-interaction': $('#ccb'),
			'cholesterol-coronary-heart-disease-risks': $('#chd'),
			'statin-warfarin-interaction': $('#warfarin'),
			'asian-patients-with-cholesterol': $('#asian')
		};
		
		specificPatients.tabLinks = $('.tab');
		specificPatients.tabContentWrapper = $('.tab-content-wrapper');
		specificPatients.tabContent = $('.tab-content');
		
		specificPatients.windowWidth = gliv.returnWindowWidth();
		specificPatients.windowHeight = gliv.returnWindowHeight();
		specificPatients.tabWrapperOffset = $(specificPatients.tabContentWrapper).offset().top;
		specificPatients.tabLinkOffsetTop = {
			'overview': $('[data-id="overview"]').offset().top - 23,
			't2d': $('[data-id="t2d"]').offset().top - 23,
			'elderly': $('[data-id="elderly"]').offset().top - 23,
			'ccb': $('[data-id="ccb"]').offset().top - 23,
			'chd': $('[data-id="chd"]').offset().top - 23,
			'warfarin': $('[data-id="warfarin"]').offset().top - 23,
			'asian': $('[data-id="asian"]').offset().top - 23
		};
		specificPatients.tabContentPositionTop = {
			'overview': $('#overview').position().top,
			't2d': $('#t2d').position().top,
			'elderly': $('#elderly').position().top,
			'ccb': $('#ccb').position().top,
			'chd': $('#chd').position().top,
			'warfarin': $('#warfarin').position().top,
			'asian': $('#asian').position().top
		};
		
		specificPatients.scrollingDueToClickOnTab = false;
		
		specificPatients.mobileCollapsibleBlock = $('.mobile-collapsible-block');
		specificPatients.mobileCollapsibleContent = $('.mobile-collapsible-content');
		specificPatients.mobileFlexHeadlineLink = $('.mobile-flex-headline');
		
		specificPatients.scrollMagicController = new ScrollMagic.Controller({
			container: '#tab-container',
			reverse: true
		});
		
		specificPatients.scrollMagicController.enabled(true);
		
		this.rE();
		this.eL();
	},
	eL: function eventListeners(){
		$(window).on('load', function(){
			if (specificPatients.windowWidth > 800) {
				var contentToUse = specificPatients.urlObject[specificPatients.urlArray[2]];
				
				specificPatients.updateActiveClass(contentToUse);
				specificPatients.updateBordersOnActiveClass(contentToUse);
				
				if (specificPatients.urlArray[2] !== 'is-livalo-right-statin'){
					specificPatients.scrollingDueToClickOnTab = true;
					specificPatients.scrollMagicController.enabled(false);
					specificPatients.scrollToContent(contentToUse);
				}
			} else {
				var mobileContentToUse = specificPatients.urlObjectMobile[specificPatients.urlArray[2]];
				
				$(mobileContentToUse).addClass('open');
				
				if (specificPatients.urlArray[2] !== 'is-livalo-right-statin'){
					var mobileContentOffset = $(mobileContentToUse).offset().top;
					$('html, body').animate({
						scrollTop: mobileContentOffset - 30
					}, 1000);
				}
			}
		});
		
		if (specificPatients.windowWidth > 800){
			$.each(specificPatients.tabLinks, function(i){
				$(this).on('click', function(e){
					e.preventDefault();
					if(! $(this).hasClass('active-tab')){
						specificPatients.scrollingDueToClickOnTab = true;
						specificPatients.scrollMagicController.enabled(false);
						specificPatients.updateActiveClass(this);
						specificPatients.updateBordersOnActiveClass(this);
						specificPatients.scrollToContent(this);
					}
				});
			});
			
			specificPatients.calculateTabContentHeight();
			
			// Scroll Event for desktop tab content section
			specificPatients.makeTabActiveOnScroll();
			
		} else {
			$.each(specificPatients.mobileFlexHeadlineLink, function(){
				$(this).on('click', specificPatients.toggleAccordion);
			})
		}

	},
	rE: function resizeEvents(){
		window.addEventListener('resize', function (){
			specificPatients.windowWidth = gliv.returnWindowWidth();
			specificPatients.windowHeight = gliv.returnWindowHeight();
			
			if (specificPatients.windowWidth > 800){
				specificPatients.calculateTabContentHeight();
				// Scroll Event for desktop tab content section
				specificPatients.makeTabActiveOnScroll();
			}
		});
	},
	updateActiveClass: function addActiveClass(tab){
		$('.active-tab').removeClass('active-tab');
		$(tab).addClass('active-tab');
	},
	updateBordersOnActiveClass: function removeActiveClass(tab){
		$('.no-border-bottom').removeClass('no-border-bottom');
		$(tab).prev('div.tab').addClass('no-border-bottom');
	},
	returnTabHeight: function returnTabHeight(){
		return $('.tab-wrapper').height();
	},
	returnFooterHeight: function returnFooterHeight(){
		return $('footer').height();
	},
	returnAsianHeight: function returnAsianHeight(){
		return $('#asian').height();
	},
	calculateTabContentHeight: function calculateTabContentHeight(){
		var tabHeight = specificPatients.returnTabHeight();
		var asianHeight = specificPatients.returnAsianHeight();
		var fullTabHeight = tabHeight + asianHeight;
		
		$(specificPatients.tabContentWrapper).css({'height': fullTabHeight + 'px'});
	},
	scrollToContent: function scrollToContent(tab){
		var tabName = $(tab).data('id');
		var diff = Math.abs(specificPatients.tabLinkOffsetTop[tabName] - specificPatients.tabContentPositionTop[tabName]) + specificPatients.tabWrapperOffset;

		if (tabName === 'overview'){
			$(specificPatients.tabContentWrapper).animate({scrollTop: 0}, 1000, function(){
				specificPatients.scrollingDueToClickOnTab = false;
				specificPatients.scrollMagicController.enabled(true);
				specificPatients.scrollMagicController.update(true);
			});
		} else {
			$(specificPatients.tabContentWrapper).animate({scrollTop: diff}, 1000, function(){
				specificPatients.scrollingDueToClickOnTab = false;
				specificPatients.scrollMagicController.enabled(true);
				specificPatients.scrollMagicController.update(true);
			});
		}
	},
	makeTabActiveOnScroll: function makeTabActiveOnScroll(){
		var overviewScene = new ScrollMagic.Scene({
			triggerElement: $('#overview'),
			triggerHook: 0,
			duration: $('#overview').height()-50
		})
			.setClassToggle("#tab-overview", "active-tab") // add class toggle
			// .addIndicators()
			.on('leave', function(){
				$('#tab-overview').removeClass('active-tab');
				overviewScene.update(true)
			})
			.addTo(specificPatients.scrollMagicController);
		
		var t2dScene = new ScrollMagic.Scene({
			triggerElement: $('#t2d'),
			triggerHook: 0.1,
			duration: $('#t2d').height()
		})
			.setClassToggle("#tab-t2d", "active-tab") // add class toggle
			// .addIndicators()
			.on('leave', function(){
				$('#tab-t2d').removeClass('active-tab');
				t2dScene.update(true)
			})
			.addTo(specificPatients.scrollMagicController);
		
		var elderlyScene = new ScrollMagic.Scene({
			triggerElement: $('#elderly'),
			triggerHook: 0.2,
			duration: $('#elderly').height()
		})
			.setClassToggle("#tab-elderly", "active-tab") // add class toggle
			// .addIndicators()
			.on('leave', function(){
				$('#tab-elderly').removeClass('active-tab');
				elderlyScene.update(true)
			})
			.addTo(specificPatients.scrollMagicController);
		
		var ccbScene = new ScrollMagic.Scene({
			triggerElement: $('#ccb'),
			triggerHook: 0.3,
			duration: $('#ccb').height()
		})
			.setClassToggle("#tab-ccb", "active-tab") // add class toggle
			// .addIndicators()
			.on('leave', function(){
				$('#tab-ccb').removeClass('active-tab');
				ccbScene.update(true)
			})
			.addTo(specificPatients.scrollMagicController);
		
		var chdScene = new ScrollMagic.Scene({
			triggerElement: $('#chd'),
			triggerHook: 0.375,
			duration: $('#chd').height()
		})
			.setClassToggle("#tab-chd", "active-tab") // add class toggle
			// .addIndicators()
			.on('leave', function(){
				$('#tab-chd').removeClass('active-tab');
				chdScene.update(true)
			})
			.addTo(specificPatients.scrollMagicController);
		
		var warfarinScene = new ScrollMagic.Scene({
			triggerElement: $('#warfarin'),
			triggerHook: 0.465,
			duration: $('#warfarin').height()+10
		})
			.setClassToggle("#tab-warfarin", "active-tab") // add class toggle
			// .addIndicators()
			.on('leave', function(){
				$('#tab-warfarin').removeClass('active-tab');
				warfarinScene.update(true)
			})
			.addTo(specificPatients.scrollMagicController);
		
		var asianScene = new ScrollMagic.Scene({
			triggerElement: $('#asian'),
			triggerHook: 0.558,
			duration: $('#asian').height()-50
		})
			.setClassToggle("#tab-asian", "active-tab") // add class toggle
			// .addIndicators()
			.on('leave', function(){
				$('#tab-asian').removeClass('active-tab');
				asianScene.update(true)
			})
			.addTo(specificPatients.scrollMagicController);
	},
	toggleAccordion: function(){
		if($(this).parent('.mobile-collapsible-block').hasClass('open')){
			$(this).parent('.mobile-collapsible-block.open').removeClass('open');
			$(this).siblings('.mobile-collapsible-content').slideUp(1000);
		} else {
			$(this).parent('.mobile-collapsible-block').addClass('open');
			$(this).siblings('.mobile-collapsible-content').slideDown(1000);
		}
	},
};
